import { escapeJsonForHtml } from '../utils';

export const PUBLIC_CONFIG_SCRIPT_ID = '__UXENG_PUBLIC_CONFIG__';
const PUBLIC_CONFIG_GLOBAL = Symbol.for('__UXENG_PUBLIC_CONFIG__');

type GlobalWithPublicConfig = {
    [PUBLIC_CONFIG_GLOBAL]?: Record<string, unknown>;
};

function getGlobal(): GlobalWithPublicConfig {
    return globalThis as unknown as GlobalWithPublicConfig;
}

export function setPublicConfig(config: Record<string, unknown>): void {
    getGlobal()[PUBLIC_CONFIG_GLOBAL] = config;
}

export function hasPublicConfig(): boolean {
    return getGlobal()[PUBLIC_CONFIG_GLOBAL] !== undefined;
}

export function getPublicConfig(): Record<string, unknown> {
    const g = getGlobal();

    if (g[PUBLIC_CONFIG_GLOBAL]) return g[PUBLIC_CONFIG_GLOBAL];

    if (typeof window !== 'undefined') {
        const el = document.getElementById(PUBLIC_CONFIG_SCRIPT_ID);
        if (!el) throw new Error(`Public config not found in DOM (#${PUBLIC_CONFIG_SCRIPT_ID}).`);

        const raw = el.textContent ?? '';
        try {
            const parsed = JSON.parse(raw) as Record<string, unknown>;
            g[PUBLIC_CONFIG_GLOBAL] = parsed;
            return parsed;
        } catch (err) {
            const msg = err instanceof Error ? err.message : String(err);
            throw new Error(`Failed to parse public config JSON: ${msg}`);
        }
    } else {
        if (process.env.NEXT_PHASE !== 'phase-production-build') {
            throw new Error('Public config not initialized server-side. Call setPublicConfig() before rendering.');
        }
    }

    throw new Error('Public config not initialized server-side. Call setPublicConfig() before rendering.');
}

export function getPublicConfigJson(): string {
    return escapeJsonForHtml(JSON.stringify(getPublicConfig()));
}

export function getConfigValue(key: string): unknown {
    return getPublicConfig()[key];
}
